// src/com/veh_info/VehInfo.js
import React, { useEffect, useState } from 'react';
import TopViewControl from '../../common/TopViewControl';
import ServiceTabs from '../menu_info/ServiceTabs';
import { menuRequestRepo } from '../../value/AppModel';
import VehInfoOwned from './VehInfoOwned';
import VehInfoRented from './VehInfoRented';
import { AppMenuUrl } from '../../value/AppConst';

export default function VehInfo({
    menu, parentMenu
}) {
    const [mountedViews, setMountedViews] = useState(() => ({
        [menu.menuUrl]: true,
    }));

    useEffect(() => {
        setMountedViews((prev) => {
            if(prev[menu.menuUrl]) return prev;
            return {...prev, [menu.menuUrl]: true};
        });
    }, [menu.menuUrl]);

    const onChangeTab = (v) => {
        const sib = parentMenu.children.find((child) => child.menuId === v);
        if(sib) {
            setMountedViews((prev) => {
                if(prev[sib.menuUrl]) return prev;
                return {...prev, [sib.menuUrl]: true};
            });
        }
        menuRequestRepo({menu:sib, parentMenu:parentMenu});
    };

    const viewServiceTags = <ServiceTabs menu={menu} parentMenu={parentMenu} onChangeTab={onChangeTab} />;

    // 운송사별 고정차, 센터별 용차
    return(
        <TopViewControl>
            {mountedViews[AppMenuUrl.VehRegisterCom] &&
                <VehInfoOwned
                    viewServiceTags={viewServiceTags}
                    show={menu.menuUrl===AppMenuUrl.VehRegisterCom}
                />
            }
            {mountedViews[AppMenuUrl.VehRegisterDC] &&
                <VehInfoRented
                    viewServiceTags={viewServiceTags}
                    show={menu.menuUrl===AppMenuUrl.VehRegisterDC}
                />
            }
        </TopViewControl>
    );
}